import ReduxStoreType from 'types/reduxStore'
import { FirebaseTimestamp } from 'firebase/index'
import startOfToday from 'date-fns/startOfToday'
import { endOfToday } from 'date-fns'

const today = new Date()
export const initialState: ReduxStoreType = {
  // 要件に応じてログインユーザーの情報として持っておきたいデータをStoreで管理する
  auth: {
    is_admin: false,
    is_signed_in: false,
    mails: [],
    role: 0,
    roles: [],
    brand_ref: undefined,
    shop_ref: undefined,
    store_ref: undefined,
    switching_store_refs: [],
    uid: '',
    device_tokens: [],
    push_settings: [],
    top_tab: 'hand_over',
    default_bread_types: [],
  },
  basket: {
    baskets: [],
    is_set_unsubscribe: false,
    unsubscribes: [],
  },
  brand: {
    confirm: {
      brand_ref: undefined,
      name: '',
      store_refs: [],
    },
    brands: [],
  },
  bread: {
    breads: [],
    breadLabels: [],
    isShownPrivate: false,
    prevEditedBread: '',
  },
  calendar: {
    activeDates: [today],
    currentDate: today,
    currentMonth: today,
    closedDates: [],
    specialHolidays: [],
    orderedDates: [],
  },
  campaign: {
    confirm: {
      background: '',
      banner: '',
      bread_ids: [],
      main_visual: '',
      name: '',
      period_start: FirebaseTimestamp.fromDate(startOfToday()),
      period_end: FirebaseTimestamp.fromDate(endOfToday()),
      status: 'private',
    },
    campaigns: [],
  },
  category: {
    categories: [],
  },
  checkout: {
    is_set_unsubscribe: false,
    orders: [],
    unsubscribes: [],
    orderTimes: [],
  },
  confirm: {
    is_being_edited: false,
    collective_stocks: {
      breads: [],
      dates: [],
      deletedMonth: undefined,
    },
    store: {
      address: {
        building: '',
        city: '',
        postal_code: '',
        state: '',
        street: '',
      },
      business_hours: {},
      description: '',
      hashtags: [],
      has_eating_area: true,
      has_schedule_types: [],
      has_stock_types: [],
      holidays: [],
      image_urls: [],
      is_sacri_station: false,
      last_order_time: {},
      last_pickup_time: {},
      name: '',
      name_kana: '',
      open_time: '',
      order_start_time: {},
      phone_number: '',
      relative_pickupable_time: {},
      scheduled_opening_date: null,
      shop_ref: undefined,
      shopping_bags: [],
      status: '',
      temporary_holiday: '',
      urls: [],
    },
    store_calendars: [],
    store_geo_search: undefined,
  },
  coupon: {
    confirm: {
      name: '',
      description: '',
      code: '',
      discount_amount: 0,
      discount_rate: 0,
      status: 'public',
      type: 'request',
      limitations: {
        is_first: false,
      },
    },
    coupons: [],
  },
  error: {
    confirm_password: '',
    email: '',
    password: '',
    stripe: '',
  },
  loading: {
    state: false,
  },
  manufacturer: {
    manufacturers: [],
    manufacturerStores: [],
  },
  modal: {
    caution: {
      actionLabel: '',
      cancelLabel: '',
      description: '',
      onClickAction: () => null,
      open: false,
      title: '',
    },
    confirm: {
      open: false,
    },
    content: undefined,
    description: '',
    edited: false,
    error: '',
    staff: {
      open: false,
      staff: undefined,
    },
    shared_bread: {
      manufacturerBread: undefined,
      retailerBreads: [],
      open: false,
    },
    bulk_stock: {
      date: '',
      open: false,
    },
    stock: {
      bread: undefined,
      date: new Date(),
      edited: false,
      open: false,
      schedules: [],
      stocks: [],
    },
    store: {
      manufacturer_ref: undefined,
      open: false,
      store_name: '',
      shop_ref: undefined,
      store_ref: undefined,
    },
    open: false,
    title: '',
  },
  nav: {
    sub_header: {
      open: false,
    },
  },
  pointCard: {
    pointCard: undefined,
  },
  pushMessage: {
    pushMessages: [],
  },
  schedule: {
    schedules: [],
  },
  shop: {
    card: undefined,
    contact: '',
    name: '',
    responsible_person: '',
    shop_id: '',
    stripe_account_id: '',
    stripe_customer_id: '',
    stripe_payment_method_id: '',
  },
  shopSubscription: {
    invoices: [],
    subscriptions: [],
    subscription_schedules: [],
    shop_subscriptions: [],
    store_refs: [],
  },
  staff: {
    staffs: [],
  },
  stock: {
    is_set_unsubscribe: false,
    stocks: [],
    unsubscribe: () => null,
  },
  store: {
    address: {
      building: '',
      city: '',
      postal_code: '',
      state: '',
      street: '',
    },
    business_hours: {},
    description: '',
    hashtags: [],
    has_eating_area: true,
    has_schedule_types: [],
    has_stock_types: [],
    holidays: [],
    image_urls: [],
    is_sacri_station: false,
    is_before_publishing_stock: false,
    last_order_time: {},
    last_pickup_time: {},
    name: '',
    name_kana: '',
    open_time: '',
    order_start_time: {},
    phone_number: '',
    relative_pickupable_time: {},
    scheduled_opening_date: null,
    shop_ref: undefined,
    shopping_bags: [],
    status: '',
    temporary_holiday: '',
    urls: [],
  },
  storeCalendar: {
    currentMonth: new Date(),
    closedStoreCalendars: [],
    orderedStoreCalendars: [],
    storeCalendars: [],
  },
  storeDeliveryBread: {
    bread_ref: undefined,
    maximum_order: 0,
    package_size: '',
    delivery_company: '',
    frozen_delivery_type: '',
    is_frozen_delivery: false,
    hours_to_deadline: 0,
    how_to_eat: '',
    how_to_store: '',
    choices: [],
    options: [],
  },
  storeDeliveryFee: {
    storeDeliveryFees: [],
  },
  storeDeliverySetting: {
    storeDeliverySettings: [],
  },
  storeShipping: {
    is_set_unsubscribe: false,
    shippings: [],
    unsubscribes: [],
  },
  storeTimesale: {
    storeTimesale: null,
  },
  tag: {
    tags: [],
  },
  user: {
    users: [],
  },
}
